export const compose = (...fns) =>
  fns.reverse().reduce(
    (prevFn, nextFn) => (value) => nextFn(prevFn(value)),
    (value) => value,
  );

export const sort_by = function (field, reverse, primer) {
  var key = primer
    ? function (x) {
        return primer(x[field]);
      }
    : function (x) {
        return x[field];
      };

  reverse = !reverse ? 1 : -1;

  return function (a, b) {
    return (a = key(a)), (b = key(b)), reverse * ((a > b) - (b > a));
  };
};

export function formatResponseStageCards(eventData) {
  let stageDetails = {};
  let stageMapping = {};
  let stageClosedEventData = [];
  let obj = {
    sectionCode: 'ACTION',
    sectionName: 'Action',
    sectionScope: 'Private',
    fields: {
      CurrencyCode: '',
      DisputeAmount: '',
      Description: '',
    },
  };
  eventData.forEach((event) => {
    stageDetails[event.caseStageId] = event.disputeStageName;
    stageMapping[event.caseStageId] = event.eventHeaderDetails.responseToCaseStageId;
    if (event.eventHeaderDetails.eventCode === 'CB_API_RES_ACK') {
      event.eventBodyDetails.push(obj);
    }
    if (event.eventHeaderDetails.eventCode === 'STAGE_CLOSE') {
      stageClosedEventData.push(event);
      event.eventBodyDetails[0].fields = Object.assign({}, event.eventBodyDetails[0].fields, {
        stageId: event.caseStageId,
      });
    }
    if (event.eventHeaderDetails.recordType === 'Response' && event.eventHeaderDetails.responseToCaseStageId !== null) {
      if (event.eventHeaderDetails.activeStageInd !== 1 && event.eventHeaderDetails.latestStageInd !== 1) {
        let parentEvent = eventData.find(
          ({ caseStageId }) => caseStageId === event.eventHeaderDetails.responseToCaseStageId,
        );
        event.eventHeaderDetails = {
          ...event.eventHeaderDetails,
          activeStageInd: parentEvent?.eventHeaderDetails?.activeStageInd,
          latestStageInd: parentEvent?.eventHeaderDetails?.latestStageInd,
        };
      }
    }
  });

  return eventData
    .filter((event) => {
      if (
        event?.eventHeaderDetails?.eventCode === 'CASE_CLOSE' &&
        event?.eventHeaderDetails?.eventGeneratedByUser === 'System' &&
        stageClosedEventData.some((caseStage) => caseStage?.caseStageId === event?.caseStageId)
      ) {
        return false;
      } else if (
        !(
          event.eventHeaderDetails.eventCode === 'NEW_CASE_STAGE' && event.eventHeaderDetails.recordType === 'Response'
        ) &&
        event.eventBodyDetails.length > 0
      ) {
        return true;
      }
      return true;
    })
    .map((event) => {
      if (
        event.eventHeaderDetails.recordType === 'Response' ||
        event.eventHeaderDetails.recordType === 'Incoming-Info' ||
        (event.eventHeaderDetails.recordType === 'Decision' && event.eventHeaderDetails.disputeStageType === 'I')
      ) {
        let target = event.eventHeaderDetails.responseToCaseStageId;
        let parent = undefined;
        do {
          parent = stageMapping[target];
          if (parent) {
            target = parent;
          }
        } while (parent);

        return {
          ...event,
          caseStageId: target,
          disputeStageName: stageDetails[target],
        };
      } else if (event.eventHeaderDetails.recordType === 'Decision') {
        let target = event.eventHeaderDetails.responseToCaseStageId;
        return {
          ...event,
          caseStageId: target,
          disputeStageName: stageDetails[target],
        };
      } else {
        return event;
      }
    });
}

export function getCardBrandCode(acquirerCode, cardBrandCode) {
  switch (acquirerCode) {
    case 'MXP':
      return 'PR';
    case 'GPNPD':
    case 'HPYPD':
      return 'PD';
    case "EMD":
      return "EV";  
    default:
      return cardBrandCode;
  }
}

export default {
  compose,
  sort_by,
  formatResponseStageCards,
  getCardBrandCode,
};
